import React from "react";
import PrivacyPolicy from "./PrivacyPolicy";
import "./App.css";

export default function App() {
  return (
    <div className="app-wrapper">
      <PrivacyPolicy />
    </div>
  );
}
